import type {
  CrudSearchItem,
  CrudSearchRule,
  CrudSelectOption,
  CrudTableColumn
} from '@/types/crud-config'
import type { LowFrequencyLiveEmpRecord } from './low-frequency-live-emp.service'

const positiveIntegerRule: CrudSearchRule = {
  validator: (
    _rule: unknown,
    value: string | number,
    callback: (error?: Error) => void
  ) => {
    if (value === '' || value === undefined || value === null) {
      callback()
      return
    }
    if (!/^\d+$/.test(String(value)) || Number(value) <= 0) {
      callback(new Error('请输入正整数'))
      return
    }
    callback()
  },
  trigger: 'blur'
}

export function createLowFrequencyLiveEmpSearchItems(
  employees: CrudSelectOption[],
  loading: boolean
): CrudSearchItem[] {
  return [
    {
      label: '员工',
      prop: 'empName',
      type: 'select',
      clearable: true,
      loading,
      placeholder: '请选择员工',
      options: employees
    },
    {
      label: '时间范围',
      prop: 'dayRange',
      type: 'input',
      placeholder: '请输入时间范围（天）',
      rules: positiveIntegerRule
    },
    {
      label: '最大观看天数',
      prop: 'maxWatchDays',
      type: 'input',
      placeholder: '请输入最大观看天数阈值',
      rules: positiveIntegerRule
    }
  ]
}

export const lowFrequencyLiveEmpTableColumns: CrudTableColumn<LowFrequencyLiveEmpRecord>[] =
  [
    {
      prop: 'channelName',
      label: '直播间名称',
      minWidth: 80,
      showOverflowTooltip: true
    },
    {
      prop: 'deptName',
      label: '部门名称',
      minWidth: 80,
      showOverflowTooltip: true
    },
    {
      prop: 'empName',
      label: '员工名称',
      minWidth: 80,
      showOverflowTooltip: true
    },
    {
      prop: 'consumerWxUnionId',
      label: '客户微信唯一编号',
      minWidth: 100,
      showOverflowTooltip: true
    },
    {
      prop: 'consumerNickName',
      label: '客户昵称',
      minWidth: 80,
      showOverflowTooltip: true
    },
    {
      prop: 'accessTime',
      label: '访问时间',
      minWidth: 80,
      showOverflowTooltip: true
    },
    { prop: 'ip', label: '访问ip', minWidth: 80 },
    { prop: 'duration', label: '观看时长:单位秒', minWidth: 80 },
    {
      prop: 'wechatEmpsStr',
      label: '客户企微所属业务员',
      minWidth: 100,
      showOverflowTooltip: true
    }
  ]
